export const api = `${process.env.REACT_APP_BACKEND_URL}/api`;
